import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        iconButton: {
            height: 30,
            width: 30,
            padding: 0,
        },
        iconButtonIcon: {
            height: 25,
            width: 25,
        },

        attachment: {
            fontSize: theme.typography.caption.fontSize,
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
        },
        downloadLink: {
            display: 'inline-block',
            maxWidth: 150,
            cursor: 'pointer',
            textDecoration: 'underline',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            justifySelf: 'flex-start',
        },
        tooltip: {
            '&$open': {
                opacity: 1,
                background: 'black',
            },
        },

        tooltipContentWrapper: {
            position: 'relative',
        },
        tooltipProgressWrapper: {
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        circularProgress: {
            color: 'white',
        },
        tooltipImage: {
            width: 300,
            height: 300,
            position: 'relative',
            zIndex: 10,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center center',
        },
    })
);
